import axios from "axios";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import { STATUS_200, STATUS_300 } from "../data/constants";
import agentAxios from "../lib/AxiosInterceptor";
import { say, complain } from "../lib/notify";
import {
    setUserHistoryData,
    setUserHistoryDataError,
    setUserHistoryDataLoading,
    setUserNotificationsData,
    setUserNotificationsDataError,
    setUserNotificationsDataLoading,
    setAgentNotificationsData,
    setAgentNotificationsDataError,
    setAgentNotificationsDataLoading
} from "../redux/userDashboard";

export const GetUserHistoryDataService = () => {
    return async (dispatch) => {
      try {
        dispatch(setUserHistoryDataLoading(true));
        const resp = await axios.get(
          `${ApiConfig.historyListData}`
        );
        if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
          dispatch(setUserHistoryData(resp?.data?.data));
          dispatch(setUserHistoryDataLoading(false));
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setUserHistoryDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        complain(e, "Errors.LoadList");
        dispatch(setUserHistoryDataLoading(false));
      }
    };
  };
  export const GetAgentHistoryDataService = () => {
    return async (dispatch) => {
      try {
        dispatch(setUserHistoryDataLoading(true));
        const resp = await agentAxios.get(
          `${ApiConfig.historyListData}`
        );
        if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
          dispatch(setUserHistoryData(resp?.data?.data));
          dispatch(setUserHistoryDataLoading(false));
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setUserHistoryDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        complain(e, "Errors.LoadList");
        dispatch(setUserHistoryDataLoading(false));
      }
    };
  };
export const GetNotificationsDataService = () => {
  return async (dispatch) => {
    try {
      dispatch(setUserNotificationsDataLoading(true));
      const resp = await axios.get(
        `${ApiConfig.notificationsListData}`
      );
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setUserNotificationsData(resp?.data?.data));
        dispatch(setUserNotificationsDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setUserNotificationsDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      complain(e, "Errors.LoadList");
      dispatch(setUserNotificationsDataLoading(false));
    }
  };
};

export const GetAgentNotificationsDataService = () => {
    return async (dispatch) => {
      try {
        dispatch(setAgentNotificationsDataLoading(true));
        const resp = await agentAxios.get(
          `${ApiConfig.notificationsListData}`
        );
        if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
          dispatch(setAgentNotificationsData(resp?.data?.data));
          dispatch(setAgentNotificationsDataLoading(false));
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setAgentNotificationsDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        complain(e, "Errors.LoadList");
        dispatch(setAgentNotificationsDataLoading(false));
      }
    };
  };
  export const UserClearHistoryService = async (payload, extraConfig) => {
    if (payload !== undefined) {
      try {
        const response = await axios.post(
          `${ApiConfig.clearHistory}`,
          payload, extraConfig
        );
        if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
          say("Notices.HistoryCleared");
          return true;
        } else {
          throw response;
        }
      } catch (e) {
        complain(e, "Errors.ClearHistory");
        return false;
      }
    }
  };
  export const UserClearNotificationsService = async (payload, extraConfig) => {
    if (payload !== undefined) {
      try {
        const response = await axios.post(
          `${ApiConfig.clearNotifications}`,
          payload, extraConfig
        );
        if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
          say("Notices.NotificationsCleared");
          return true;
        } else {
          throw response;
        }
      } catch (e) {
        complain(e, "Errors.ClearNotifications");
        return false;
      }
    }
  };
  export const AgentClearHistoryService = async (payload, extraConfig) => {
    if (payload !== undefined) {
      try {
        const response = await agentAxios.post(
          `${ApiConfig.clearHistory}`,
          payload, extraConfig
        );
        if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
          say("Notices.HistoryCleared");
          return true;
        } else {
          throw response;
        }
      } catch (e) {
        complain(e, "Errors.ClearHistory");
        return false;
      }
    }
  };
  export const AgentClearNotificationsService = async (payload, extraConfig) => {
    if (payload !== undefined) {
      try {
        const response = await agentAxios.post(
          `${ApiConfig.clearNotifications}`,
          payload, extraConfig
        );
        if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
          say("Notices.NotificationsCleared");
          return true;
        } else {
          throw response;
        }
      } catch (e) {
        complain(e, "Errors.ClearNotifications");
        return false;
      }
    }
  };
  